import React, { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & {
  secondaryfill?: string;
  strokewidth?: number;
  title?: string;
};

function Crowd({
  strokewidth: _strokewidth = 1,
  width = "1em",
  height = "1em",
  ...props
}: IconProps) {
  return (
    <svg
      height={height}
      width={width}
      {...props}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor">
        <path
          d="M4.25002 13.75C2.38302 13.75 0.708021 14.999 0.176021 16.786C0.108021 17.013 0.152021 17.259 0.294021 17.448C0.436021 17.638 0.658021 17.75 0.895021 17.75H7.60502C7.84202 17.75 8.06402 17.638 8.20602 17.448C8.34802 17.259 8.39202 17.013 8.32402 16.786C7.79202 14.998 6.11702 13.75 4.25002 13.75Z"
          fill="currentColor"
        />
        <path
          d="M13.75 13.75C11.883 13.75 10.208 14.999 9.67602 16.786C9.60802 17.013 9.65202 17.259 9.79402 17.448C9.93602 17.638 10.158 17.75 10.395 17.75H17.105C17.342 17.75 17.564 17.638 17.706 17.448C17.848 17.259 17.892 17.013 17.824 16.786C17.292 14.998 15.617 13.75 13.75 13.75Z"
          fill="currentColor"
        />
        <path
          d="M4.25 12.5005C5.35457 12.5005 6.25 11.6051 6.25 10.5005C6.25 9.39592 5.35457 8.50049 4.25 8.50049C3.14543 8.50049 2.25 9.39592 2.25 10.5005C2.25 11.6051 3.14543 12.5005 4.25 12.5005Z"
          fill="currentColor"
        />
        <path
          d="M13.75 12.5005C14.8546 12.5005 15.75 11.6051 15.75 10.5005C15.75 9.39592 14.8546 8.50049 13.75 8.50049C12.6454 8.50049 11.75 9.39592 11.75 10.5005C11.75 11.6051 12.6454 12.5005 13.75 12.5005Z"
          fill="currentColor"
        />
        <path
          d="M9 4.50049C10.1046 4.50049 11 3.60506 11 2.50049C11 1.39592 10.1046 0.500488 9 0.500488C7.89543 0.500488 7 1.39592 7 2.50049C7 3.60506 7.89543 4.50049 9 4.50049Z"
          fill="currentColor"
        />
        <path
          d="M7.66976 9.75195H10.3302C10.5665 8.66729 11.3058 7.77046 12.2913 7.31799C11.4985 6.3528 10.2955 5.75195 9.00001 5.75195C7.7047 5.75195 6.5018 6.35316 5.70892 7.31812C6.69436 7.77063 7.43347 8.6674 7.66976 9.75195Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default Crowd;
